import { orderByPhonesUrl } from './resources.js';
import common from './common.js';



async function createOrderByPhoneService(data) {
    let url = `${orderByPhonesUrl}`;
    return await common.postData(url, data);          
}

async function createOrderByPhoneServiceWithSMSNotification(data) {
    let url = `${orderByPhonesUrl}/CreateOrderByPhoneServiceWithSMSNotification`;
    return await common.postData(url, data);
}

async function createOrderByPhoneServiceWithOrderManager(data) {
    let url = `${orderByPhonesUrl}/CreateOrderByPhoneServiceWithOrderManager`;
    return await common.postData(url, data);
}


export default {
    name: 'itemsService',
    createOrderByPhoneService,
    createOrderByPhoneServiceWithSMSNotification,
    createOrderByPhoneServiceWithOrderManager
} 